import { render, staticRenderFns } from "./CategoriesAdd.vue?vue&type=template&id=46d5e7d4&scoped=true&"
import script from "./CategoriesAdd.vue?vue&type=script&lang=js&"
export * from "./CategoriesAdd.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesAdd.vue?vue&type=style&index=0&id=46d5e7d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d5e7d4",
  null
  
)

export default component.exports